import "./scene-8-new.css";

const menuCircle = document.querySelector(".launcher-1");
const menuCross = document.querySelector(".launcher-1-cross");
const launcher2 = document.querySelector(".launcher-2");
const launcher3 = document.querySelector(".launcher-3");
const launcher4 = document.querySelector(".launcher-4");
const wowAnimation = document.querySelector(".scene-8-svg");

const addAnime = () => {
  menuCircle.className = "launcher-1";
  menuCross.className = "launcher-1-cross anime";
  launcher2.className = "launcher-2 anime";
  launcher3.className = "launcher-3 anime";
  launcher4.className = "launcher-4 anime";
};

const resetAnime = () => {
  menuCircle.className = "launcher-1";
  menuCross.className = "launcher-1-cross";
  launcher2.className = "launcher-2";
  launcher3.className = "launcher-3";
  launcher4.className = "launcher-4";
};

menuCross.addEventListener("click", () => {
  if (menuCross.className === "launcher-1-cross") {
    return addAnime();
  }
});

menuCircle.addEventListener("click", () => {
  if (menuCircle.className === "launcher-1") {
    return resetAnime();
  }
});

launcher2.addEventListener("click", () => {
  if (window.innerWidth <= 840) {
    document
      .querySelector(".scene-5-para")
      .scrollIntoView({ behavior: "smooth" });
  } else {
    document.querySelector(".scene-6").scrollIntoView({ behavior: "smooth" });
  }
});

launcher3.addEventListener("click", () => {
  if (window.innerWidth <= 840) {
    document
      .querySelector(".scene-2-img")
      .scrollIntoView({ behavior: "smooth" });
  } else {
    document.querySelector(".scene-3").scrollIntoView({ behavior: "smooth" });
  }
});

launcher4.addEventListener("click", () => {
  if (window.innerWidth <= 840) {
    document
      .querySelector(".scene-2-img")
      .scrollIntoView({ behavior: "smooth" });
  } else {
    document.querySelector(".scene-3").scrollIntoView({ behavior: "smooth" });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 840) {
    wowAnimation.className = "scene-8-svg";
  }
});
